import * as React from "react";

interface Props extends React.PropsWithChildren {
  style?: React.CSSProperties;
}

export const CardTitle: React.FC<Props> = ({ children, style = {} }) => {
  return (
    <div className={"cpln-ant-card-title"} style={style}>
      {children}
    </div>
  );
};
